import { create } from 'jss';
import JSSCamelCase from 'jss-camel-case';
import JSSNested from 'jss-nested';

export const createJSS = (() => {
  let jss;

  return () => {
    if (jss) return jss;
    jss = create();
    jss.use(JSSCamelCase(), JSSNested());
    return jss
  }
})();

export const createStyleSheet = (...args) => {
  const JSS = createJSS();
  return JSS.createStyleSheet(...args);
};

export const attachStyleSheet = (...args) => {
  const styleSheet = createStyleSheet(...args);
  styleSheet.attach();
  return styleSheet;
};

export const getStyleSheetClasses = (...args) => {
  const styleSheet = attachStyleSheet(...args);
  return styleSheet.classes;
};


// WEBPACK FOOTER //
// ./src/services/jss.js